function Step2WbbHomepageContent({
    templateState,
    setTemplateField,

    logoImageFile,
    setLogoImageFile,

    heroImageFile,
    setHeroImageFile,

    existingLogoImageUrl,
    existingHeroImageUrl,

    removeLogoImage,
    setRemoveLogoImage,

    removeHeroImage,
    setRemoveHeroImage,
}) {
    return (
        <div className="card">
            <h2>SF Pickup WBB homepage content</h2>

            <div className="row-2">
                <label className="field">
                    <span>Hero eyebrow</span>
                    <input
                        value={templateState.hero_eyebrow || ""}
                        onChange={(e) =>
                            setTemplateField("hero_eyebrow", e.target.value)
                        }
                    />
                </label>

                <label className="field">
                    <span>Hero title</span>
                    <input
                        value={templateState.hero_title || ""}
                        onChange={(e) =>
                            setTemplateField("hero_title", e.target.value)
                        }
                        placeholder="SF Pickup WBB"
                    />
                </label>
            </div>

            <label className="field">
                <span>Hero subtitle</span>
                <textarea
                    value={templateState.hero_subtitle || ""}
                    onChange={(e) =>
                        setTemplateField("hero_subtitle", e.target.value)
                    }
                    className="textarea"
                    rows={3}
                    placeholder="Competition, community, and women’s basketball in San Francisco."
                />
            </label>

            <div className="row-2">
                <label className="field">
                    <span>Hero button text</span>
                    <input
                        value={templateState.hero_button_label || ""}
                        onChange={(e) =>
                            setTemplateField("hero_button_label", e.target.value)
                        }
                        placeholder="REGISTER NOW"
                        maxLength={30}
                    />
                </label>

                <label className="field">
                    <span>Hero button link</span>
                    <input
                        value={templateState.hero_button_link || ""}
                        onChange={(e) =>
                            setTemplateField("hero_button_link", e.target.value)
                        }
                        placeholder="/registration or https://..."
                    />
                </label>
            </div>
            <div className="field">
                <span>Logo image</span>

                {existingLogoImageUrl && !logoImageFile && !removeLogoImage ? (
                    <div className="existing-file-row">
                        <span className="existing-file-pill">
                            Current logo image uploaded
                        </span>

                        <a
                            href={existingLogoImageUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="existing-file-link"
                        >
                            View
                        </a>

                        <button
                            type="button"
                            className="existing-file-remove"
                            onClick={() => {
                                setRemoveLogoImage(true);
                                setLogoImageFile(null);
                            }}
                        >
                            Remove
                        </button>
                    </div>
                ) : null}

                {removeLogoImage ? (
                    <div className="existing-file-row">
                        <span className="existing-file-pill">
                            Logo image will be removed
                        </span>

                        <button
                            type="button"
                            className="existing-file-link"
                            onClick={() => setRemoveLogoImage(false)}
                        >
                            Undo
                        </button>
                    </div>
                ) : null}

                <div className="file-row">
                    <input
                        id="wbb-logo-upload"
                        type="file"
                        accept="image/*"
                        className="file-hidden"
                        onChange={(e) => {
                            const file = e.target.files?.[0] || null;
                            setLogoImageFile(file);

                            if (file) {
                                setRemoveLogoImage(false);
                            }
                        }}
                    />

                    <label htmlFor="wbb-logo-upload" className="file-btn">
                        Choose File
                    </label>

                    <div className="file-name">
                        {logoImageFile?.name || "No file chosen"}
                    </div>
                </div>
            </div>
            <div className="field">
                <span>Main hero image</span>

                {existingHeroImageUrl && !heroImageFile && !removeHeroImage ? (
                    <div className="existing-file-row">
                        <span className="existing-file-pill">
                            Current hero image uploaded
                        </span>

                        <a
                            href={existingHeroImageUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="existing-file-link"
                        >
                            View
                        </a>

                        <button
                            type="button"
                            className="existing-file-remove"
                            onClick={() => {
                                setRemoveHeroImage(true);
                                setHeroImageFile(null);
                            }}
                        >
                            Remove
                        </button>
                    </div>
                ) : null}

                {removeHeroImage ? (
                    <div className="existing-file-row">
                        <span className="existing-file-pill">
                            Hero image will be removed
                        </span>

                        <button
                            type="button"
                            className="existing-file-link"
                            onClick={() => setRemoveHeroImage(false)}
                        >
                            Undo
                        </button>
                    </div>
                ) : null}

                <div className="file-row">
                    <input
                        id="wbb-hero-upload"
                        type="file"
                        accept="image/*"
                        className="file-hidden"
                        onChange={(e) => {
                            const file = e.target.files?.[0] || null;
                            setHeroImageFile(file);

                            if (file) {
                                setRemoveHeroImage(false);
                            }
                        }}
                    />

                    <label htmlFor="wbb-hero-upload" className="file-btn">
                        Choose File
                    </label>

                    <div className="file-name">
                        {heroImageFile?.name || "No file chosen"}
                    </div>
                </div>
            </div>

            <label className="field">
                <span>Tournament section title</span>
                <input
                    value={templateState.tournament_section_title || ""}
                    onChange={(e) =>
                        setTemplateField(
                            "tournament_section_title",
                            e.target.value
                        )
                    }
                    placeholder="Tournament Details"
                />
            </label>

            <label className="field">
                <span>Tournament section subtitle</span>
                <textarea
                    value={templateState.tournament_section_subtitle || ""}
                    onChange={(e) =>
                        setTemplateField(
                            "tournament_section_subtitle",
                            e.target.value
                        )
                    }
                    className="textarea"
                    rows={3}
                    placeholder="Everything you need to know before game day."
                />
            </label>

            <div className="row-2">
                <label className="field">
                    <span>Tournament date</span>
                    <input
                        value={templateState.tournament_date || ""}
                        onChange={(e) =>
                            setTemplateField("tournament_date", e.target.value)
                        }
                        placeholder="August 29"
                    />
                </label>

                <label className="field">
                    <span>Tournament price</span>
                    <input
                        value={templateState.tournament_price || ""}
                        onChange={(e) =>
                            setTemplateField("tournament_price", e.target.value)
                        }
                        placeholder="$80 / Player"
                    />
                </label>
            </div>

            <div className="row-2">
                <label className="field">
                    <span>Tournament format</span>
                    <input
                        value={templateState.tournament_format || ""}
                        onChange={(e) =>
                            setTemplateField("tournament_format", e.target.value)
                        }
                        placeholder="5 vs. 5 Full Court"
                    />
                </label>

                <label className="field">
                    <span>Games per team</span>
                    <input
                        value={templateState.tournament_games || ""}
                        onChange={(e) =>
                            setTemplateField("tournament_games", e.target.value)
                        }
                        placeholder="3–5 Games Per Team"
                    />
                </label>
            </div>

            <label className="field">
                <span>Tournament location</span>
                <input
                    value={templateState.tournament_location || ""}
                    onChange={(e) =>
                        setTemplateField("tournament_location", e.target.value)
                    }
                    placeholder="UCSF"
                />
            </label>
        </div>
    );
}

export default Step2WbbHomepageContent;